import React from "react";
import Image from "./image.js";
import { Link } from "gatsby";
import popular from "../popular.json";

const PopularIcons = () => {
  return (
    <>
      <h2>Popular Icons</h2>
      <ul id="popular">
        {
          popular.map(popularIcon => {
            return (<li key={popularIcon.path}>
              <Link
                to={ "/"+popularIcon.path }
                title={ "View and download icon: "+popularIcon.name }
              >
                <Image
                  src={ popularIcon.icon }
                  alt={ popularIcon.name }
                />
                <h3>{ popularIcon.name }</h3>
                <span data-provider={ popularIcon.provider.slug }>
                  { popularIcon.provider.name }
                </span>
              </Link>
            </li>)
          })
        }
      </ul>
    </>
  );
};
export default PopularIcons;
